import { useEffect, useMemo, useState } from "react";
import { useApi } from "@/lib/api";

const rand = (seed) => { let x = Math.sin(seed) * 10000; return x - Math.floor(x); };
const series = (base, n, seed) => { const out = [base]; for (let i = 1; i < n; i++) out.push(out[i - 1] * (1 + (rand(seed + i) - 0.5) * 0.006)); return out; };

export const useDemoMarket = () => {
  const { data } = useApi("market", "/market/demo", { staleTime: Infinity });
  const [tick, setTick] = useState(0);
  useEffect(() => { const id = setInterval(() => setTick((t) => t + 1), 2500); return () => clearInterval(id); }, []);
  return useMemo(() => {
    if (!data) return { label: "Illustrative data", rows: [] };
    const rows = data.instruments.map((ins, i) => {
      const pts = series(ins.base, 40, i * 7 + Math.floor(tick / 6));
      const last = pts[pts.length - 1] * (1 + (rand(tick + i * 13) - 0.5) * 0.002);
      const chg = ((last - ins.base) / ins.base) * 100;
      return { ...ins, pts, last, chg, price: `${ins.prefix}${last.toLocaleString("en-IN", { minimumFractionDigits: ins.decimals, maximumFractionDigits: ins.decimals })}` };
    });
    return { label: data.label, rows };
  }, [data, tick]);
};

export const Sparkline = ({ pts, up, w = 120, h = 36 }) => {
  const min = Math.min(...pts), max = Math.max(...pts);
  const d = pts.map((p, i) => `${(i / (pts.length - 1)) * w},${h - ((p - min) / (max - min || 1)) * (h - 4) - 2}`).join(" ");
  return <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} aria-hidden="true" className="overflow-visible"><polyline fill="none" stroke={up ? "var(--up)" : "var(--down)"} strokeWidth="1.5" points={d} style={{ transition: "all .6s" }} /></svg>;
};

export const MarketTape = ({ compact }) => {
  const { rows, label } = useDemoMarket();
  if (!rows.length) return null;
  const items = [...rows, ...rows];
  return (
    <div data-testid="market-tape" className={`overflow-hidden border-b border-white/5 bg-[#050912] ${compact ? "py-1.5" : "py-3"}`} aria-label={label}>
      <div className="ticker-track font-mono text-xs">
        {items.map((r, i) => (
          <span key={i} className="flex items-center gap-2 px-6 whitespace-nowrap">
            <span className="text-slate-400">{r.symbol}</span><span className="text-slate-100 tabular-nums">{r.price}</span>
            <span className={r.chg >= 0 ? "up" : "down"}>{r.chg >= 0 ? "▲" : "▼"} {Math.abs(r.chg).toFixed(2)}%</span>
            {i % rows.length === rows.length - 1 && <span className="ml-4 text-[10px] uppercase tracking-widest text-slate-600">{label}</span>}
          </span>
        ))}
      </div>
    </div>
  );
};
